/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import {
	FormControl, Button, IconButton, TextField, Chip
} from '@mui/material';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';

const LogsSuperadminModalFilter = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(25);
	const [orderBy] = useState("createdAt");
	const [order] = useState("asc");

	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const [searchTextUsers, setSearchTextUsers] = useState('');
	const [usersFormated, setUsersFormated] = useState([]);
	const [selectedUsers, setSelectedUsers] = useState([])

	const [selectedTypes, setSelectedTypes] = useState([]);
	const [searchTextType, setSearchTextType] = useState('');

	const [searchTextOperationsName, setSearchTextOperationsName] = useState('');
	const [selectedOperationsName, setSelectedOperationsName] = useState([]);

	const [searchTextTables, setSearchTextTables] = useState('');
	const [selectedTables, setSelectedTables] = useState([]);

	const [selectedDocumentsIds, setSelectedDocumentsIds] = useState([]);
	const [selectedDocumentsIdsError, setSelectedDocumentsIdsError] = useState('');
  const [inputValueDocumentId, setInputValueDocumentId] = useState('');

	const [searchTextTenants, setSearchTextTenants] = useState('');
	const [tenantsFormated, setTenantsFormated] = useState([]);
	const [selectedTenants, setSelectedTenants] = useState([])

	const handleInputChangeAccountables = () => {
    const docId = inputValueDocumentId.trim();
		const regex = /^[A-Za-z0-9]*$/;
		const docIdIsValid = regex.test(docId) && docId.length === 24
		const index = selectedDocumentsIds.indexOf(docId);

    if (docId != '' && docIdIsValid && index < 0) {
      setSelectedDocumentsIds([...selectedDocumentsIds, docId]);
      setInputValueDocumentId('');
      setSelectedDocumentsIdsError('');
    } else if (docIdIsValid && index > -1) {
      if (docId !== '') setSelectedDocumentsIdsError('Id já selecionado!');
    } else {
			if (docId !== '') setSelectedDocumentsIdsError('Id inválido! Deve conter 24 caracteres sendo apenas letras e números');
		}
  }

	const handleDeleteIdFromDocumentsIds = (docId) => {
    const index = selectedDocumentsIds.indexOf(docId);
    if (index >= 0) setSelectedDocumentsIds([...selectedDocumentsIds.slice(0, index), ...selectedDocumentsIds.slice(index+1)]);
  }


	const fetchUsers = useCallback(
		() => dispatch(actions.fetchLogsSuperadminOptionsUsers(page, limit, searchTextUsers, order, orderBy)),
		[page, limit, searchTextUsers, order, orderBy]
	);

	const fetchTenants = useCallback(
		() => dispatch(actions.fetchLogsSuperadminOptionsTenants(page, limit, searchTextTenants, order, orderBy)),
		[page, limit, searchTextTenants, order, orderBy]
	);

	const me = useSelector(state => state.auth);
	const types = useSelector(state => state.logsSuperadmin.types);
	const operationsName = useSelector(state => state.logsSuperadmin.operationsName);
	const tables = useSelector(state => state.logsSuperadmin.tables)

	const logsFilter = useSelector(state => state.logsSuperadmin.logsFilter);
	const filteredStartDate = useSelector(state => state.logsSuperadmin.logsFilter.startDate);
	const filteredEndDate = useSelector(state => state.logsSuperadmin.logsFilter.endDate);
	const filteredUsers = useSelector(state => state.logsSuperadmin.logsFilter.filteredUsers);
	const filteredTypes = useSelector(state => state.logsSuperadmin.logsFilter.filteredTypes);
	const filteredOperationNames = useSelector(state => state.logsSuperadmin.logsFilter.filteredOperationsName)
	const filteredTables = useSelector(state => state.logsSuperadmin.logsFilter.filteredTables)
	const filteredDocumentsIds = useSelector(state => state.logsSuperadmin.logsFilter.filteredDocumentsIds)
	const filteredTenants = useSelector(state => state.logsSuperadmin.logsFilter.filteredTenants)

	const loadingTenants= useSelector(state => state.logsSuperadmin.loadingTenants);
	const tenants= useSelector(state => state.logsSuperadmin.tenants);

	const loadingUsers= useSelector(state => state.logsSuperadmin.loadingUsers);
	const users= useSelector(state => state.logsSuperadmin.users);

	useEffect(() => {
		handleInputChangeUsers(filteredUsers);
		handleInputChangeTenants(filteredTenants);
		handleInputChangeTypes(filteredTypes);
		handleInputChangeOperationsName(filteredOperationNames);
		handleInputChangeTables(filteredTables);
		setStartDate(filteredStartDate ? filteredStartDate : null);
		setEndDate(filteredEndDate ? filteredEndDate : null);
		setSelectedDocumentsIds(filteredDocumentsIds ? filteredDocumentsIds : [])
	}, []);

	useEffect(() => {
		fetchUsers(limit, searchTextUsers, order, orderBy);
	}, [searchTextUsers]);

	useEffect(() => {
		const dataFromRedux = users
		let returnArray = []
		returnArray.push({value: me._id, label: me.name})
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setUsersFormated(returnArray)
	}, [users])

	useEffect(() => {
		fetchTenants(limit, searchTextTenants, order, orderBy);
	}, [searchTextTenants]);

	useEffect(() => {
		const dataFromRedux = tenants
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setTenantsFormated(returnArray)
	}, [tenants])

	const handleInputChangeSelectorUsers = (text) => {
		setSearchTextUsers(text);
	} 

	const handleInputChangeSelectorTenants = (text) => {
		setSearchTextTenants(text);
	} 

	const handleInputChangeSelectorTypes = (text) => {
		setSearchTextType(text);
	}

	const handleInputChangeSelectorOperationsName = (text) => {
		setSearchTextOperationsName(text)
	}

	const handleInputChangeSelectorTables = (text) => {
		setSearchTextTables(text)
	}

	const handleInputChangeUsers = selected => {
		setSelectedUsers(selected);
	}

	const handleInputChangeTenants = selected => {
		setSelectedTenants(selected);
	}

	const handleInputChangeTypes = selected => {
		setSelectedTypes(selected);
	}

	const handleInputChangeOperationsName = selected => {
		setSelectedOperationsName(selected);
	}

	const handleInputChangeTables = selected => {
		setSelectedTables(selected);
	}

	const handleClickFilter = () => {
		dispatch(actions.fetchLogsSuperadmin(page, logsFilter.limit, logsFilter.search, logsFilter.order, logsFilter.orderBy, startDate, endDate, selectedUsers, selectedTypes, selectedOperationsName, selectedTables, selectedDocumentsIds, selectedTenants))
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedUsers([])
		setSelectedTenants([])
		setSelectedTypes([])
		setSelectedOperationsName([])
		setSelectedTables([])
		setSelectedDocumentsIds([])
		setStartDate(null)
		setEndDate(null)
	}

	return (
        <div style={styles.container}>			
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					FILTROS
					{((selectedUsers && selectedUsers.length > 0) || 
					(selectedTypes && selectedTypes.length > 0) ||
					(selectedOperationsName && selectedOperationsName.length > 0) ||
					(selectedTables && selectedTables.length > 0) ||
					(selectedDocumentsIds && selectedDocumentsIds.length > 0))
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>limpar filtros</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>	
					<FormControl variant="standard" style={{ width: '45%' }} margin='normal'>
						<MobileDateTimePicker
							label='Data de criação de:'
							margin='normal'
							value={startDate && new Date(startDate)}
							onChange={date => setStartDate(date ?  date : null)}
							format="dd/MM/yyyy HH:mm"
							ampm={false}
							disableFuture
							slotProps={{ textField: { variant: 'standard', } }}
						/>
					</FormControl>
					<FormControl variant="standard" style={{ width: '45%' }} margin='normal'>
						<MobileDateTimePicker
							label='Data de criação até:'
							margin='normal'
							value={endDate && new Date(endDate)}
							onChange={date => setEndDate(date ?  date : null)}
							format="dd/MM/yyyy HH:mm"
							disableFuture
							ampm={false}
							slotProps={{ textField: { variant: 'standard', } }}
						/>
					</FormControl>
				</div>
			<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingUsers}
						label='Usuários'
						data={usersFormated}
						onSelectValue={handleInputChangeUsers}
						valueSelected={selectedUsers}
						newSearchText={handleInputChangeSelectorUsers}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingTenants}
						label='Locatários'
						data={tenantsFormated}
						onSelectValue={handleInputChangeTenants}
						valueSelected={selectedTenants}
						newSearchText={handleInputChangeSelectorTenants}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label='Tipo'
						data={types}
						onSelectValue={handleInputChangeTypes}
						valueSelected={selectedTypes}
						newSearchText={handleInputChangeSelectorTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label='Tipo de operação'
						data={operationsName}
						onSelectValue={handleInputChangeOperationsName}
						valueSelected={selectedOperationsName}
						newSearchText={handleInputChangeSelectorOperationsName}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						label='Tabela'
						data={tables}
						onSelectValue={handleInputChangeTables}
						valueSelected={selectedTables}
						newSearchText={handleInputChangeSelectorTables}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<TextField
                        variant="standard"
                        label='Documents (ids)'
                        name='documents_ids'
                        placeholder='Insira o id do documento e aperte espaço para adicionar'
                        onChange={event => setInputValueDocumentId(event.target.value)}
                        onKeyDown={event => [32, 9, 13].includes(event.keyCode) ? handleInputChangeAccountables() : setSelectedDocumentsIdsError('')}
                        onBlur={event => handleInputChangeAccountables()}
                        value={ inputValueDocumentId }
                        InputProps={{
							startAdornment: selectedDocumentsIds.map(item => (
								<Chip
									key={item}
									tabIndex={-1}
									label={item}
									style={styles.chip}
									onDelete={() => handleDeleteIdFromDocumentsIds(item)}
								/>
							))}}
                        margin='normal'
                        error={selectedDocumentsIdsError !== ''}
                        helperText={selectedDocumentsIdsError} />
				</FormControl>
			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
					CANCELAR
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
					APLICAR
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: '#008100',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: '#008100',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem', 
		marginLeft: '2rem', 
		color: '#fff', 
		cursor: 'pointer', 
		textDecoration: 'underline' 
	}
}


export default LogsSuperadminModalFilter;

